import StarIcon from '../../shared/Icons/StarIcon';
import DashboardIcon from '../../shared/Icons/DashboardIcon';
import TicketSettingsIcon from '../../shared/Icons/TicketSettingsIcon';
import MarketingChartIcon from '../../shared/Icons/MarketingChartIcon';

// Single source of truth for the per-event row actions. Consumed by both the
// kebab menu (RowActionsMenu) and the hover button group in the Event cell
// (TicketsTable), so the two stay in sync.
export function buildRowActions(team, event) {
  const base = `/teams/${team.id}/confirms/${event.id}`;
  return [
    { key: 'details', href: base, label: 'Event details', tip: 'View event details', Icon: StarIcon },
    { key: 'dashboard', href: `${base}/dashboard`, label: 'Ticketing dashboard', tip: 'Ticketing dashboard', Icon: DashboardIcon },
    { key: 'ticketing', href: `${base}/ticketing`, label: 'Ticket setup', tip: 'Ticket setup', Icon: TicketSettingsIcon },
    { key: 'marketing_insights', href: `${base}/marketing_insights`, label: 'Marketing Insights', tip: 'Marketing Insights', Icon: MarketingChartIcon },
  ];
}

export default buildRowActions;
